import moment from 'moment';
import { isPositiveNumber } from '@/helpers/common.js';

export const formatTime = (
  value,
  fallbackValue,
  { showHours = false } = {},
) => {
  if (!isPositiveNumber(value, true)) { return fallbackValue; }

  const minutes = Math.floor((value % 3600) / 60);
  const seconds = value % 60;

  return [
    ...(showHours ? [Math.floor(value / 3600)] : []),
    minutes,
    seconds,
  ].map(v => v.toString().padStart(2, '0')).join(':');
};

export const getTimeDuration = (startDate, endDate) => {
  const __startDate = moment(startDate);
  const __endDate = moment(endDate);

  return Math.ceil(moment.duration(__endDate.diff(__startDate)).asHours());
};

export const getTimeRange = (startDate, endDate) =>
  [startDate, endDate].map(date => moment(date).format('HH:mm:ss')).join(' - ');
